import { useParams } from "react-router";
import { Trans, useTranslation } from "@coworker/locales";
import FullScreenPopup from "@coworker/apprestructured/src/layout/components/FullScreenPopup/FullScreenPopup";
import { useTasksForProduct } from "../hooks/useTasksForProduct";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import TaskList from "@coworker/apprestructured/src/tasks/components/TaskList/TaskList";
import { TaskCardSkeleton } from "@coworker/apprestructured/src/tasks/components/TaskCard/TaskCardSkeleton";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import { ModalContext } from "@coworker/apprestructured/src/layout/context/ModalContextProvider";
import { ModalType } from "@coworker/apprestructured/src/layout/context/modalType";
import { useContext, useCallback } from "react";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";

export const RelatedTasks = () => {
  const { id } = useParams();
  const tasks = useTasksForProduct(id);
  const { data: basicItem, isLoading: isItemInfoLoading } = useItemInfo(
    id ?? ""
  );
  const { toggleModal } = useContext(ModalContext);
  const { t } = useTranslation();

  const onShowTaskDetails = useCallback(
    (taskId: string, taskType: TaskType) => {
      toggleModal({
        type: ModalType.TaskDetail,
        payload: { taskId, taskType },
      });
    },
    [toggleModal]
  );

  if (tasks.loading || isItemInfoLoading)
    return (
      <>
        <TaskCardSkeleton />
        <TaskCardSkeleton />
        <TaskCardSkeleton />
        <TaskCardSkeleton />
      </>
    );

  return (
    <FullScreenPopup
      appBarConfig={{
        title: <Trans>relatedTasksString</Trans>,
        subtitle: (
          <>
            {!!id && (
              <>
                {basicItem?.noFormatted}
                {!!basicItem?.name && (
                  <>
                    {" • "}
                    {basicItem?.name}
                  </>
                )}
              </>
            )}
          </>
        ),
      }}
      linkbar={
        <Linkbar
          items={[
            {
              label: t("TasksString"),
              to: "/tasks",
            },
          ]}
          currentLabel={t("relatedTasksString")}
          currentAsH1
        />
      }
      noPadding
    >
      <TaskList
        tasks={tasks.list}
        totalTasksCount={tasks.formattedCount}
        basicItem={basicItem!}
        type=""
        showTasksCount={false}
        onShowTaskDetails={onShowTaskDetails}
      />
    </FullScreenPopup>
  );
};
